import React from "react"
import {
  iconSizeCss,
  statusIconColorCss,
  type StatusIconProps,
} from "@myvp/shared/src/styles/icon-utils"

const Warning = (props: StatusIconProps) => {
  if (props.size === "small") {
    return (
      <svg
        {...props}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        css={[
          iconSizeCss(props.size),
          statusIconColorCss("warning", props.variant),
        ]}
      >
        <path
          d="M8 1.75C8.06855 1.75 8.14623 1.78196 8.20117 1.88184L14.209 12.8018C14.2666 12.9067 14.2611 13.0232 14.209 13.1182C14.1575 13.2117 14.0831 13.2499 14.0078 13.25H1.99219C1.91689 13.2499 1.84247 13.2117 1.79102 13.1182C1.73893 13.0232 1.73345 12.9067 1.79102 12.8018L7.79883 1.88184C7.85377 1.78196 7.93145 1.75 8 1.75Z"
          stroke="var(--shapeStrokeColor)"
          fill="var(--shapeFillColor)"
          strokeWidth="1.5"
        />
        <path
          d="M8 6V9.07692M8 11.5V9.84615"
          stroke="var(--textColor)"
          strokeWidth="1.5"
        />
      </svg>
    )
  }

  if (props.size === "large") {
    return (
      <svg
        {...props}
        className={props.className}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        css={[
          iconSizeCss(props.size),
          statusIconColorCss("warning", props.variant),
        ]}
      >
        <path
          d="M15.134 2.5C15.5189 1.83333 16.4811 1.83333 16.866 2.5L30.7224 26.5C31.1073 27.1667 30.6262 28 29.8564 28H2.14359C1.37379 28 0.892668 27.1667 1.27757 26.5L15.134 2.5Z"
          stroke="var(--shapeStrokeColor)"
          fill="var(--shapeFillColor)"
          strokeWidth="2"
        />
        <path
          d="M16 8L16 19.3333M16 22.1667L16 25"
          stroke="var(--textColor)"
          strokeWidth="2"
        />
      </svg>
    )
  }

  // Default to props.size === "medium"
  return (
    <svg
      {...props}
      className={props.className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      css={[
        iconSizeCss("medium"),
        statusIconColorCss("warning", props.variant),
      ]}
    >
      <path
        d="M21.749 20H2.25098L12 3.46875L21.749 20Z"
        stroke="var(--shapeStrokeColor"
        fill="var(--shapeFillColor)"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12 9V13.8M12 15.4V17"
        stroke="var(--textColor)"
        strokeWidth="2"
      />
    </svg>
  )
}

export default Warning
